import { createAsyncThunk } from '@reduxjs/toolkit';
import type { GetServerSidePropsContext } from 'next';

import doFetch from 'utils/doFetch';

import type { AppGetState } from '../../index';

const getProductsThunks = createAsyncThunk(
  'paymentsMethods/getPaymentsMethods',
  async (context: GetServerSidePropsContext | null, { getState }) => {
    const apiPointName = 'getPaymentsMethods';
    const store = (getState as AppGetState)();
    const token = store.jwt.token;
    let headers = {};

    if (token) {
      headers = {
        ...headers,
        Authorization: `Bearer ${token}`,
      };
    }

    return await doFetch<typeof apiPointName>({
      apiPointName,
      body: null,
      context,
      headers,
    });
  },
);

export default getProductsThunks;
